export default class CurrentUser {
  static isLoggedIn() {
    return this.userObject().loggedIn;
  }

  static id() {
    return this.userObject().id;
  }

  static email() {
    return this.userObject().email;
  }

  static fullName() {
    return this.userObject().fullName;
  }

  static firstName() {
    return this.userObject().firstName;
  }

  static lastName() {
    return this.userObject().lastName;
  }

  static isGuest() {
    return this.userObject().isUser;
  }

  static isUser() {
    return this.userObject().isUser;
  }

  static isSubscriber() {
    return this.userObject().isSubscriber;
  }

  static isAuthor() {
    return this.userObject().isAuthor;
  }

  static isEditor() {
    return this.userObject().isEditor;
  }

  static isAdmin() {
    return this.userObject().isAdmin;
  }

  static roles() {
    return Object.entries({
      guest: this.isGuest(),
      subscriber: this.isSubscriber(),
      author: this.isAuthor(),
      editor: this.isEditor(),
      admin: this.isAdmin(),
    })
      .filter(([_key, value]) => value)
      .map(([key, _value]) => key);
  }

  static getProfileImage(width = 75, height = 75) {
    return (
      this.userObject().profileImage['baseUrl'] + `&w=${width}&h=${height}`
    );
  }

  static bookmarks() {
    return this.userObject().bookmarks;
  }

  static trialConversions() {
    return window.ENV.trialConversions;
  }

  static endorsedComments() {
    return this.userObject().endorsedComments;
  }

  static addEndorsedComment(id) {
    window.ENV.currentUser.endorsedComments.push(id);
  }

  static removeEndorsedComment(id) {
    window.ENV.currentUser.endorsedComments =
      window.ENV.currentUser.endorsedComments.filter((xid) => xid !== id);
  }

  static hasFeatureEnabled(featureName) {
    return this.userObject().enabledFeatures.includes(featureName);
  }

  static userObject() {
    if (window && window.ENV && window.ENV.currentUser) {
      return window.ENV.currentUser;
    } else {
      return {};
    }
  }
}
